module.exports = __webpack_public_path__ + "static/media/project18.f2a256fc.jpg";